export const roles = [
  { id: 1, label: 'Administrator', value: 'Admin' },
  { id: 2, label: 'Module Lead', value: 'ModuleLead' },
  { id: 3, label: 'Instructor', value: 'Instructor' },
  { id: 4, label: 'Assistant Instructor', value: 'AssistantInstructor' },
  { id: 5, label: 'Community Manager', value: 'CommunityManager' },
  { id: 6, label: 'Data Analyst', value: 'DataAnalyst' },
  { id: 7, label: 'Support Admin', value: 'SupportAdmin' },
  { id: 8, label: 'Partner Admin', value: 'PartnerAdmin' },
];

export const SUPER_ADMIN_ROLE_OPTION = {
  id: 0,
  label: 'Super Admin',
  value: 'SuperAdmin',
};

export const rolesWithSuperAdmin = [SUPER_ADMIN_ROLE_OPTION, ...roles];

export const ADMIN_LEVEL_ROLES = ['SuperAdmin', 'Admin'];

export const ELEVATED_ROLES = ['SuperAdmin', 'Admin', 'ModuleLead'];

export const isAdminOrAbove = (role) => {
  return ADMIN_LEVEL_ROLES.includes(role);
};

export const isSuperAdmin = (role) => {
  return role === 'SuperAdmin';
};

export const hasElevatedAccess = (role) => {
  return ELEVATED_ROLES.includes(role);
};

export function getRolesForPermissionEditor(viewerRole) {
  return viewerRole === 'SuperAdmin' ? rolesWithSuperAdmin : roles;
}

export function getRolesForUserCreation(viewerRole) {
  return viewerRole === 'SuperAdmin' ? rolesWithSuperAdmin : roles;
}
